<template>
  <v-container>
    <h1>New Task</h1>
    <v-form @submit.prevent="createTask">
      <v-text-field
        v-model="uniqueId"
        label="Unique ID"
        required
      ></v-text-field>
      <v-file-input
        v-for="docType in docList"
        v-model="data[toJsonKey(docType)]"
        :label="docType"
        accept=".pdf,.jpg,.png"
        required
      ></v-file-input>
      <v-text-field
        v-for="textType in textInput"
        v-model="data[toJsonKey(textType)]"
        :label="textType"
        required
        class="ml-8"
      ></v-text-field>
      <v-btn type="submit" color="primary" :loading="loading">Start Task</v-btn>
    </v-form>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'NewTask',
  props:{
    taskType: {
      type: String
    },
    docList: {
      type: Array
    },
    textInput: {
      type: Array,
      default: () => []
    },
    beforeCreate: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      uniqueId: '',
      data: {},
      loading: false
    }
  },
  methods: {
    toJsonKey(value) {
      return value.replace(" ", "_").toLowerCase()
    },
    async createTask() {
      this.loading = true

      try {
        // Create data object
        const taskData = {
          unique_id: this.uniqueId,
          task_type: this.taskType
        }
        
        // Add document inputs
        for (const doc of this.docList) {
          const jsonKey = this.toJsonKey(doc)
          taskData[jsonKey] = this.data[jsonKey]
        }
        
        // Add text inputs
        for (const text of this.textInput) {
          const jsonKey = this.toJsonKey(text)
          taskData[jsonKey] = this.data[jsonKey] || ''
        }
        
        // Call beforeCreate if it exists
        let processedData = taskData
        if (this.beforeCreate) {
          processedData = await this.beforeCreate(taskData)
        }

        // Convert to FormData
        const formData = new FormData()
        for (const [key, value] of Object.entries(processedData)) {
          formData.append(key, value)
        }
        
        await this.$http.post(`/api/tasks/${this.taskType}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        
        this.$router.push('tasks')
      } catch (error) {
        console.error('Error creating task:', error)
        alert(`Failed to create task: ${error.response.data.detail}`)
      }
      this.loading = false
    }
  }
}
</script>